import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Box, Grid, Typography, Chip } from '@the-platform-group/component-library'
import { Close as CloseIcon } from '@the-platform-group/component-library/Icons'

/**
 * Component to display a list of files that are either currently uploading or have been uploaded
 * for Irwin Assistant instructions. Shows file names, sizes and upload status.
 *
 * @param {object} props - Component props
 * @param {Array} props.uploadedFiles - Array of files that have completed uploading
 * @param {Array} props.pendingFiles - Array of files currently being uploaded
 * @param {function} props.onFileRemove - Callback function to remove an uploaded file
 * @returns {React.ReactElement} The rendered UploadedFilesDisplay component
 */
const UploadedFilesDisplay = ({ uploadedFiles = [], pendingFiles = [], onFileRemove }) => {
  if (isEmpty(uploadedFiles) && isEmpty(pendingFiles)) {
    return null
  }

  return (
    <Box>
      {uploadedFiles.map(file => (
        <Chip
          key={file.name}
          label={
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <Typography variant="subtitle2">{file.name}</Typography>
              </Grid>
              {file.size && (
                <Grid item>
                  <Typography variant="caption" color="text.secondary">
                    ({(file.size / 1024 / 1024).toFixed(2)} MB)
                  </Typography>
                </Grid>
              )}
            </Grid>
          }
          variant="attachment"
          onDelete={() => onFileRemove(file)}
          deleteIcon={<CloseIcon />}
        />
      ))}
      {pendingFiles.map(file => (
        <Chip
          key={file.name}
          label={
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <Typography variant="subtitle2">{file.name}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="caption" color="text.secondary">
                  (Uploading...)
                </Typography>
              </Grid>
            </Grid>
          }
          variant="attachment"
          disabled
        />
      ))}
    </Box>
  )
}

export default UploadedFilesDisplay
